import PropTypes from "prop-types";
import { Modal, CustomContainer } from "../../../atoms/DependencyHelper";
import Image from "../../../atoms/image/image";
import styles from './ClickAndCollectModal.module.scss';
import SearchStoreClickAndCollect from "../../searchStoreClickAndCollect/SearchStoreClickAndCollect";
import { imagePrefix } from "../../../../utils/helperServices";

const ClickAndCollectModal = ({
  sku,
  isModalOpen, 
  hideModal, 
  geoLocationIsAllowed, 
  storeAddress, 
  selectedStore
}) => {
    return (
      <>
        { isModalOpen &&
          <Modal
            show={true}
            onHide={()=>console.log('onHide')}
            dialogClassName={`centered-dialog ${styles["stores-modal"]}`}
            centered
          >
          <Modal.Header className={`"modal-header" ${styles["close-btn-position"]}`}>
            <span className={`${styles["close-position"]}`}>
              <Image
                className={"close-button"}
                img_path={`${imagePrefix}/assets/images/modal-close.svg`}
                onClick={hideModal}
              />
            </span>
          </Modal.Header>
            
            <Modal.Body className={"modal-body p-0"}>
              <CustomContainer>
                <SearchStoreClickAndCollect 
                  sku={sku}
                  header="Check which stores have this product in stock"
                  text="Try searching for your town, suburb or favourite shopping centre"
                  geoLocationIsAllowed={geoLocationIsAllowed}
                  storeAddress={storeAddress}
                  callBackSelectedStore={selectedStore}
                />
              </CustomContainer>
            </Modal.Body>
          </Modal>
        }
      </>
    );
};

ClickAndCollectModal.propTypes = {
  sku: PropTypes.string,
  isModalOpen: PropTypes.bool,
  geoLocationIsAllowed: PropTypes.bool,
  hideModal: PropTypes.func,
  selectedStore: PropTypes.func,
  storeAddress: PropTypes.array
}

export default ClickAndCollectModal;